import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 py-14 md:py-20">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-background-50 tracking-tight">
                css<span className="text-accent-500">spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-xs">
              Your trusted source for the latest CSSBuy spreadsheet lists, proxy shopping guides, and agent comparisons. Updated weekly to help you shop smarter.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-5 font-label">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">Home</Link></li>
              <li><Link to="/article/best-cssbuy-spreadsheet-guide-2026" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">CSSBuy Spreadsheet Guide</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">Main Store</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-5 font-label">
              Categories
            </h4>
            <ul className="space-y-3">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">{cat.name}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-5 font-label">
              More Categories
            </h4>
            <ul className="space-y-3">
              {categories.slice(6).map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">{cat.name}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-700/30 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} CSSSpreadsheet.ink &mdash; All external links open on kaspreadsheet.com
          </p>
          <p className="text-xs text-foreground-500">
            Not affiliated with CSSBuy. An independent proxy shopping resource.
          </p>
        </div>
      </div>

      <div className="w-full overflow-hidden h-24 md:h-32 flex items-center justify-center bg-foreground-950/50">
        <span className="font-heading text-[clamp(3rem,10vw,8rem)] font-extrabold text-foreground-700/20 tracking-[-0.04em] select-none whitespace-nowrap">
          CSSBUY&bull;SPREADSHEET
        </span>
      </div>
    </footer>
  );
}